import React, { useContext, useState } from 'react'
import { Button, Checkbox, Dialog, DialogActions, EasyTable, Form, FormSection, TextField, useForm, useObservable } from '@cicero/ui'
import { AttributeSchema, PageTemplateDoc, PageTemplateSchema, StoreContext, useModel } from 'models'
import { TemplateChooser } from 'forms'

export const TemplateSettings = () => {
  const Templates = useModel(PageTemplateSchema)
  const templates = useObservable(() => Templates.QUERY$(), [], [])
  const [editing, setEditing] = useState<PageTemplateDoc|null>(null)

  const addNewTemplate = async () => {
    const tmpl = await Templates.NEW({})
    setEditing(tmpl)
  }

  return <FormSection title="Templates" action={<Button variant="contained" color="primary" onClick={addNewTemplate}>New Template</Button>}>
    <EasyTable
      data={templates}
      columns={[
        { title: 'Name', value: (t) => t.name },
        { title: 'Attribute Count', value: (t) => t.template_attributes?.length || 0 },
        { title: '', value: (t) => <Button onClick={() => setEditing(t)}>Edit</Button>, cellProps: { align: 'right' } },
      ]}
    />
    <Dialog fullWidth open={editing !== null} onClose={() => setEditing(null)}>
      { editing ? <TemplateForm template={editing} onClose={() => setEditing(null)} /> : null }
    </Dialog>
  </FormSection>
}

export const TemplateForm = ({ template, onClose }: { template: PageTemplateDoc, onClose: () => void }) => {
  const store = useContext(StoreContext)
  const Attributes = useModel(AttributeSchema)
  const attributes = useObservable(() => Attributes.QUERY$(), [], [])
  const $form = useForm({
    async onSubmit({ values }) {
      const { name } = values
      await template.atomicUpdate(t => {
        if (!t.id) {
          const { session } = store
          t.owner_id = session?.url.path || ''
        }

        t.name = name
        return t
      })
      onClose()
    },
    initialValues: () => ({
      name: template.name,
      parent: template.parent_id,
      template_attributes: template.template_attributes || [],
    }),
  })

  return <Form onSubmit={$form.handleSubmit}>
    <h1>Edit Template</h1>

    <TextField label="Name" required variant="outlined" {...$form.props('name')} />
    <TemplateChooser label="Parent Template" {...$form.props('parent')} />

    <EasyTable
      data={attributes}
      columns={[
        {
          title: '',
          value: (a) => <Checkbox checked={template?.template_attributes?.find(t => t.attribute_id === a.id) !== undefined} />,
          cellProps: { width: 60 },
        },
        { title: 'Name', value: (a) => a.label },
      ]}
    />

    <DialogActions>
      <Button color="primary" onClick={() => onClose()}>Cancel</Button>
      <Button type="submit" color="primary">Save</Button>
    </DialogActions>
  </Form>
}
